import { useState, useRef, useLayoutEffect } from 'react';
import { motion, useViewportScroll, useTransform, useSpring, useReducedMotion } from 'framer-motion';
var Parallax = function (_a) {
    var children = _a.children, _b = _a.offset, offset = _b === void 0 ? 50 : _b;
    var _c = useState(0), elementTop = _c[0], setElementTop = _c[1];
    var _d = useState(0), clientHeight = _d[0], setClientHeight = _d[1];
    var ref = useRef(null);
    var prefersReducedMotion = useReducedMotion();
    var scrollY = useViewportScroll().scrollY;
    // start animating our element when we've scrolled it into view
    var initial = elementTop - clientHeight;
    // end our animation when we've scrolled the offset specified
    var final = elementTop + offset;
    var yRange = useTransform(scrollY, [initial, final], [offset, -offset]);
    // apply a spring to ease the result
    var y = useSpring(yRange, { stiffness: 400, damping: 90 });
    useLayoutEffect(function () {
        var element = ref.current;
        if (element !== null) {
            // save our layout measurements in a function in order to trigger
            // it both on mount and on resize
            var onResize_1 = function () {
                // use getBoundingClientRect instead of offsetTop in order to
                // get the offset relative to the viewport
                setElementTop(element.getBoundingClientRect().top + window.scrollY || window.pageYOffset);
                setClientHeight(window.innerHeight);
            };
            onResize_1();
            window.addEventListener('resize', onResize_1);
            return function () { return window.removeEventListener('resize', onResize_1); };
        }
    }, [ref]);
    // Don't parallax if the user has "reduced motion" enabled
    if (prefersReducedMotion) {
        return <>{children}</>;
    }
    return (<motion.div ref={ref} style={{ y: y }}>
      {children}
    </motion.div>);
};
export default Parallax;
